import * as React from "react";
import { PurposeComponentProps } from "./purpose.types";
import { PurposeIcons } from '@/constants';


const Purpose: React.FC<PurposeComponentProps> = ({ purpose, className, label, iconClassName }) => {
  return (
    (<div className={`purpose-component flex items-center ${className}`}>
      <PurposeIcon purpose={purpose} iconClassName={iconClassName} />
      <span className="capitalize truncate">{label ? label(purpose.replace(/_/g, ' ').toLowerCase()) : purpose.replace(/_/g, ' ').toLowerCase()}</span>
    </div>)
  );
};

const PurposeIcon: React.FC<PurposeComponentProps> = ({ purpose, iconClassName }) => {
  const IconComponent = PurposeIcons[purpose]?.component;

  return IconComponent ? (
    <div className={`text-purpose-${purpose.toLowerCase()}`}>
      {/* @ts-expect-error: IconComponent is a component */}
      <IconComponent className={`w-4 h-4 mr-2 ${iconClassName}`} />
    </div>
  ) : null;
};
  

export { Purpose, PurposeIcon, PurposeIcons };
